import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { parseServerDate } from '../../utils/formatDate';

export default function AdminCompanies({ showToast }) {
  const { authFetch } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    const p = new URLSearchParams();
    if (search) p.set('search', search);
    authFetch(`/api/admin/companies?${p}`).then(r => r.json()).then(d => { setCompanies(Array.isArray(d) ? d : []); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="page-title">All Companies</div>
          <span className="admin-sidebar-badge">ADMIN</span>
        </div>
        <div className="page-sub">Every organizational workspace on the platform</div>
      </div>

      <div className="g4" style={{ marginBottom: 20 }}>
        {[
          { label: 'Total Companies', val: companies.length, color: 'var(--gold-2)' },
          { label: 'With Responses', val: companies.filter(c => (c.response_count || 0) > 0).length, color: 'var(--green)' },
          { label: 'With Documents', val: companies.filter(c => (c.doc_count || 0) > 0).length, color: 'var(--gold)' },
          { label: 'Pro Owners', val: companies.filter(c => c.owner_plan === 'pro' || c.owner_plan === 'enterprise').length, color: 'var(--accent2)' },
        ].map(s => (
          <div key={s.label} className="card" style={{ padding: '14px 18px' }}>
            <div style={{ fontFamily: 'var(--ff-m)', fontSize: 26, fontWeight: 500, color: s.color }}>{s.val}</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        <input className="form-input" style={{ maxWidth: 300 }} placeholder="Search company or owner email..."
          value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()} />
        <button className="btn btn-primary btn-sm" onClick={load}>Search</button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><div className="loader" style={{ margin: '0 auto' }}></div></div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="table">
            <thead><tr><th>Company</th><th>Industry</th><th>Owner</th><th>Plan</th><th>Responses</th><th>Docs</th><th>Created</th></tr></thead>
            <tbody>
              {companies.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: 32, color: 'var(--text3)' }}>No companies found</td></tr>}
              {companies.map(c => (
                <tr key={c.id}>
                  <td><div style={{ fontWeight: 600, color: 'var(--text)', fontSize: 13 }}>{c.name}</div><div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'var(--ff-m)', marginTop: 2 }}>{c.id.slice(0, 8)}...</div></td>
                  <td style={{ fontSize: 12 }}>{c.industry || '—'}</td>
                  <td style={{ fontFamily: 'var(--ff-m)', fontSize: 11, color: 'var(--text2)' }}>{c.owner_email}</td>
                  <td><span className={`badge plan-${c.owner_plan}`} style={{ fontSize: 10 }}>● {c.owner_plan?.toUpperCase()}</span></td>
                  <td><span style={{ fontFamily: 'var(--ff-m)', color: 'var(--gold-2)', fontSize: 14 }}>{c.response_count || 0}</span></td>
                  <td><span style={{ fontFamily: 'var(--ff-m)', color: 'var(--gold)', fontSize: 14 }}>{c.doc_count || 0}</span></td>
                  <td style={{ fontSize: 11, color: 'var(--text3)' }}>{parseServerDate(c.created_at).toLocaleDateString('en-IN')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
